import { Box, Typography } from "@material-ui/core"
import SingleButtonSelection from "components/Reusable/Bit/SingleButtonSelection"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"
import colors from "theme/colors"
import HeadingText from "../Texts/HeadingText"

const StyledBox = styled(Box)`
  margin-top: 30px;
  position: relative;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 20px;
  }
  > div {
    margin-top: 20px;
  }
`

const StyledButtonWrapper = styled(Box)`
  button {
    padding-left: 10px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: 25%;
      :last-child {
        padding-left: 0px;
      }
    }
  }
`

const StyledLabel = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
`

const StyledButton = styled(Box)<{ $isSelected?: boolean }>`
  width: 70px;
  height: 50px;
  background-color: #f7f7f7;
  color: ${(p) => (p.$isSelected ? "#264F36" : "#757575")};
  border: ${(p) => (p.$isSelected ? "1px solid #264F36" : "none")};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "NarkisBlock";
  font-size: 24px;
  font-weight: bold;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    height: 46px;
    margin-left: 10px;
    line-height: 23px;
  }

  :hover {
    border: 1px solid ${colors.darkGreen};
  }
`

const StyledError = styled(Typography).attrs({ variant: "body1" })`
  color: #d70202;
  font-size: 18px;
  line-height: 1;
  text-align: right;
  position: absolute;
  bottom: -20px;
`

type GiftCardFrequencyProps = {
  setFrequency: Dispatch<SetStateAction<string>>
  scheduleError: string
  frequency: string
  setScheduleEndTime: Dispatch<SetStateAction<string>>
}

const GiftCardFrequency = ({
  setFrequency,
  scheduleError,
  frequency,
  setScheduleEndTime,
}: GiftCardFrequencyProps) => {
  const buttons = [
    { value: "Daily", text: "כל יום" },
    { value: "Weekly", text: "כל שבוע" },
    { value: "Monthly", text: "כל חודש" },
    { value: "Yearly", text: "כל שנה" },
  ]

  const handleButtonClick = (code) => {
    setFrequency(code)
    setScheduleEndTime(null)
  }

  return (
    <StyledBox>
      <HeadingText text="כל כמה זמן לחדש את שליחת דמי הכיס?" />
      <StyledButtonWrapper>
        <SingleButtonSelection
          id="scheduleSelect"
          items={buttons.map((amount) => ({
            value: amount.value,
            name: amount.text,
          }))}
          noFocus
          onSelect={(code) => handleButtonClick(code)}
          gap={15}
          itemsPerRow={"auto"}
          allowEmpty
          selectedValue={frequency}
          customButton={(radioId, isSelected, item) => {
            return (
              <>
                <StyledLabel htmlFor={radioId} $activeButton={isSelected}>
                  <StyledButton $isSelected={isSelected}>
                    <>{item.name}</>
                  </StyledButton>
                </StyledLabel>
              </>
            )
          }}
        />
      </StyledButtonWrapper>
      {scheduleError && !frequency && (
        <StyledError>{scheduleError}</StyledError>
      )}
    </StyledBox>
  )
}

export default GiftCardFrequency
